module.exports = __webpack_public_path__ + "static/media/group-icon.c2166a6a.svg";